import { removeClassFromAllElements } from './helpers';
import { skeletonInit } from './setAnalyticsCard';
import getAnalyticalMarkets from '../api/getAnalyticalMarkets';

const SELECT_ELEMENTS = {
    container: '.js-select-container',
    label: '.js-select-label',
    field: '.js-select-field',
    text: '.js-select-text',
    optionItem: '.js-select-item',
    activeClassName: 'is-active',
    emptyClassName: 'not-empty',
    input: '.js-select-input',
};

function handlerClickSelect(select, selectContainer) {
    if (select.classList.contains(SELECT_ELEMENTS.activeClassName)) {
        select.classList.remove(SELECT_ELEMENTS.activeClassName);
    } else {
        removeClassFromAllElements(selectContainer, SELECT_ELEMENTS.activeClassName);
        select.classList.add(SELECT_ELEMENTS.activeClassName);
    }
}

function handlerClickOption(data, itemOption) {
    const {
        select,
        selectOptions,
        selectField,
        selectText,
        selectLabel,
        hiddenInput
    } = data;

    const date = itemOption.getAttribute('id');

    if (date) {
        skeletonInit(true);
        getAnalyticalMarkets(date);
    }

    removeClassFromAllElements(selectOptions, SELECT_ELEMENTS.activeClassName);
    itemOption.classList.add(SELECT_ELEMENTS.activeClassName);
    hiddenInput.value = itemOption.textContent;
    selectText.textContent = itemOption.textContent;

    if (selectLabel) {
        selectField.classList.add(SELECT_ELEMENTS.emptyClassName);
    }

    select.classList.remove(SELECT_ELEMENTS.activeClassName);
}

export default function selectInit() {
    const selectContainer = document.querySelectorAll(SELECT_ELEMENTS.container);
    if (!selectContainer) return false;

    selectContainer.forEach((select) => {
        const selectOptions = select.querySelectorAll(SELECT_ELEMENTS.optionItem);
        const selectField = select.querySelector(SELECT_ELEMENTS.field);
        const selectText = selectField.querySelector(SELECT_ELEMENTS.text);
        const selectLabel = selectField.querySelector(SELECT_ELEMENTS.label);
        const hiddenInput = select.querySelector(SELECT_ELEMENTS.input);

        // eslint-disable-next-line no-unused-expressions
        selectText.textContent.length
            ? selectField.classList.add(SELECT_ELEMENTS.emptyClassName)
            : selectField.classList.remove(SELECT_ELEMENTS.emptyClassName);

        if (!selectLabel) {
            selectField.classList.remove(SELECT_ELEMENTS.emptyClassName);
        }

        selectField.addEventListener('click', () => {
            handlerClickSelect(select, selectContainer);
        });

        selectOptions.forEach((option) => {
            option.addEventListener('click', () => {
                handlerClickOption({
                    select,
                    selectOptions,
                    selectField,
                    selectText,
                    selectLabel,
                    hiddenInput
                }, option);
            });
        });
    });

    document.addEventListener('click', (event) => {
        if (!event.target.closest(SELECT_ELEMENTS.container)) {
            removeClassFromAllElements(selectContainer, SELECT_ELEMENTS.activeClassName);
        }
    });
}
